import { render, staticRenderFns } from "./SystemLayout.vue?vue&type=template&id=8978df6a&scoped=true"
import script from "./SystemLayout.vue?vue&type=script&lang=js"
export * from "./SystemLayout.vue?vue&type=script&lang=js"
import style0 from "./SystemLayout.vue?vue&type=style&index=0&id=8978df6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8978df6a",
  null
  
)

export default component.exports